export const FLOW_CONTROL_COLORS = {
    iconDefault: "#567280",
    iconActive: "#344054",
    border: "#e0e0e0",
    hoverBg: "#f5f7f9",
    panelBg: "white"
};

export const flowControlStyles = {
    /** White rounded panel used as wrapper for all control widgets */
    panel: {
        backgroundColor: FLOW_CONTROL_COLORS.panelBg,
        border: `1px solid ${FLOW_CONTROL_COLORS.border}`,
        borderRadius: "12px",
        overflow: "hidden"
    },
    /** Flex row with fixed 36px height — compose with `panel` for icon-bar containers */
    panelRow: {
        display: "flex",
        alignItems: "center",
        height: 36
    },
    /** Square icon button inside a panel — no radius, full height, hover tint */
    squareIconButton: {
        borderRadius: 0,
        height: "100%",
        "&:hover": { backgroundColor: FLOW_CONTROL_COLORS.hoverBg }
    },
    /** Default icon colour */
    icon: {
        color: FLOW_CONTROL_COLORS.iconDefault
    },
    /** 1 px vertical divider between icon buttons */
    divider: {
        width: "1px",
        height: 20,
        backgroundColor: FLOW_CONTROL_COLORS.border
    }
};
